<template>
  <div>
    <img
      class="toCurrentPosition"
      src="images/toCurrentPosition.png"
      alt=""
      @click="setCurrentPositionToCenter()"
    />
    <!--<l-map
      v-if="busStopList.length > 0"
      ref="map"
      class="map"
      style="z-index: 10; width: 100%"
      v-bind:style="mapHeight"
      :zoom.sync="zoom"
      :center.sync="center"
      :bounds="bounds"
      :options="lMapOptions"
    >--><l-map
      v-if="busStopList.length > 0"
      ref="map"
      class="map"
      style="z-index: 10; width: 100%"
      v-bind:style="mapHeight"
      :center.sync="center"
      :options="lMapOptions"
      :maxBounds="bounds_all"
      :minZoom="minZoom"
      :zoom="zoom"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <!--<l-marker :lat-lng="busLatLng"></l-marker>-->
      <!--home-->
      <l-marker
        :lat-lng="{ lat: homeLat, lng: homeLon }"
        v-show="homeLat != null && homeLon != null"
        @click="homeClick()"
      >
        <l-icon
          :icon-size="[40, 60]"
          :icon-anchor="[20, 60]"
          icon-url="images/home_icon.png"
        />
      </l-marker>
      <!--cross-->
      <l-marker
        :lat-lng="crossLatlon"
        v-if="homeLat == null || homeLon == null"
        :zIndexOffset="1000"
      >
        <l-icon
          :icon-size="[32, 32]"
          :icon-anchor="[16, 16]"
          icon-url="images/cross.gif"
        />
      </l-marker>
      <l-marker
        v-for="(marker, index) in busStop"
        :key="marker.id + index"
        :lat-lng="marker.latlon"
        @click="selectToGo(marker.id)"
      >
        <l-icon
          v-if="marker.cate == '1'"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 53]"
          icon-url="images/bus_stop_icon_1.png"
        />
        <l-icon
          v-if="marker.cate == '2'"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 53]"
          icon-url="images/bus_stop_icon_2.png"
        />
        <l-icon
          v-if="marker.cate == '3'"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 53]"
          icon-url="images/bus_stop_icon_3.png"
        />
        <l-icon
          v-if="marker.cate == '4'"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 53]"
          icon-url="images/bus_stop_icon_4.png"
        />
        <l-icon
          v-if="marker.cate == '5'"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 53]"
          icon-url="images/bus_stop_icon_5.png"
        />
        <!--<l-popup :options="busStopPopupOptions">
          <div class="primary--text">{{ marker.name }}</div>
          <div v-for="(title, index) in marker.titles" :key="'tit-' + index">
            <a :href="title.uri" target="_blank">{{ title.title }}</a>
          </div>
        </l-popup>-->
      </l-marker>
      <v-rotated-marker v-if="driverMode" :lat-lng="busLatLng" ref="busMarker_1"
        ><l-icon
          icon-url="images/mobile_icon_current.png"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 60]"
        ></l-icon>
      </v-rotated-marker>

      <v-rotated-marker
        v-for="(marker, index) in mobilityData"
        :key="marker.id"
        :lat-lng="[marker.lat, marker.lon]"
        :ref="'mobilityMarker' + index"
      >
        <!--<l-icon
          :icon-url="liconUrl(marker.id)"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 60]"
        ></l-icon>-->
        <l-icon
          icon-url="images/mobile_icon_taxi.png"
          :icon-size="[40, 60]"
          :icon-anchor="[20, 60]"
        ></l-icon>
        <!--<l-popup
          v-if="Number(marker.id) % 2 == 1 && marker.id != currentMobilityId"
          :content="popupContent(marker.id, marker.passengers, marker.capacity)"
          :options="popupOptions"
        />
        <l-popup
          v-if="Number(marker.id) % 2 != 1 && marker.id != currentMobilityId"
          :content="popupContent(marker.id, marker.passengers, marker.capacity)"
          :options="popupOptions2"
        />-->
      </v-rotated-marker>
    </l-map>
  </div>
</template>

<script>
//import { LMap, LTileLayer, LMarker, LIcon, LPopup } from "vue2-leaflet";
import {
  LMap,
  LTileLayer,
  LIcon, //LPopup,
  LMarker,
} from "vue2-leaflet";
import store from "../store";
import Export from "../export";
import { latLng, latLngBounds } from "leaflet";
import Vue2LeafletRotatedMarker from "vue2-leaflet-rotatedmarker";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    //LPopup,
    "v-rotated-marker": Vue2LeafletRotatedMarker,
  },
  mounted() {
    var ths = this;
    if (this.driverMode == true) {
      ths.getBusPosition();
    } else {
      //this.getMobilityDataTimerId = setInterval(this.getMobilityData, 3000);
    }
    this.getMobilityDataTimerId = setInterval(
      this.getMobilityData,
      this.getCrewsInterval
    );
    /*this.$nextTick(() => {
      if (this.driverMode == true) {
        this.$refs.busMarker_1.mapObject.openPopup();
      }
    });*/
    this.home.latlon = {
      lat: 33.419111999691765,
      lon: 130.5294874417847,
    };
    var center = this.$refs.map.mapObject.getCenter();
    this.$refs.map.mapObject.on("move", function () {
      var centerMove = ths.$refs.map.mapObject.getCenter();
      ths.crossLatlon = {
        lat: centerMove.lat,
        lon: centerMove.lng,
      };
    });
    this.$nextTick(() => {
      this.crossLatlon = {
        lat: center.lat,
        lon: center.lng,
      };
    });
    /*if (this.homeLat == null || this.homeLon == null) {
      this.btmMsg =
        "自宅を登録します。地図をスクロール、拡大／縮小して赤い十字を自宅の場所に合わせて【設定】を押してください。";
    } else {
      this.btmMsg =
        "予約する場合は、行先のバス停アイコンをタップしてください。予約ダイアログが表示されます。";
    }*/
  },
  data() {
    return {
      displayMap: true,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      //url: "http://localhost/toyota_coniq_ride_kiyama/map/tile/{z}/{x}/{y}.jpg",
      //url: "http://localhost/toyota_coniq_ride_kiyama/map/tile/{z}/{x}/{y}.jpg",
      attribution:
        '© <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      //zoom: 16,
      zoom: 17,
      bounds_all: [
        [33.45401153996267, 130.4834784470949],
        [33.39808124744949, 130.55405888030552],
      ],
      minZoom: 13,
      watch_id: "",
      //errorMSG: "error=",
      popupOptions: {
        closeButton: false,
        autoClose: false,
        closeOnEscapeKey: false,
        closeOnClick: false,
        className: "busPopup",
        autoPan: false,
        offset: [60, -40],
      },
      popupOptions2: {
        closeButton: false,
        autoClose: false,
        closeOnEscapeKey: false,
        closeOnClick: false,
        className: "busPopup",
        autoPan: false,
        offset: [-60, -40],
      },
      lMapOptions: {
        zoomControl: true,
        dragging: true,
        scrollWheelZoom: true,
      },
      busStopPopupOptions: { className: "busStopPopup" },
      busPopupText1: "1/7人乗車中",
      getMobilityDataNum: 0,
    };
  },
  methods: {
    async getMobilityData() {
      for (var i = 0; i < this.numbers.length; i++) {
        var getCrews = await Export.getCrews(this.numbers[i]);
        if (getCrews.data.length > 0) {
          var lat = getCrews.data[0].latitude;
          var lon = getCrews.data[0].longitude;
          this.mobilityData[i].lat = lat;
          this.mobilityData[i].lon = lon;
        }
      }
      /*var getMobilityData = await Export.getMobilityData();
      if (getMobilityData.data.length != 0) {
        this.mobilityData = getMobilityData.data;
        var inBreakMobilities = [];
        for (i = 0; i < this.mobilityData.length; i++) {
          var mm = "mobilityMarker" + String(i);
          if (this.$refs[mm] != undefined && this.$refs[mm].length == 1) {
            this.$refs[mm][0].mapObject.openPopup();
          }
          if (this.mobilityData[i].break == "true") {
            inBreakMobilities.push(this.mobilityData[i].id);
          }
          this.inBreakMobilities = inBreakMobilities;
        }
      }
      //リクエスト中
      if (this.nowRequestingId != null) {
        var query = "?id=" + this.nowRequestingId;
        var getRequestDataQuery = await Export.getRequestDataQuery(query);
        this.requestedData = getRequestDataQuery.data[0];
        if (this.is_json(this.requestedData.accepted) == true) {
          //acceptedカラムが空でなかったら
          var requestArry = JSON.parse(this.requestedData.accepted);
          var accepted = false;
          var mobilityId;
          for (var i = 0; i < requestArry.length; i++) {
            if (requestArry[i].accepted == true) {
              accepted = true;
              mobilityId = requestArry[i].mobilityId;
            }
          }
          if (accepted == true) {
            this.comingMobility = mobilityId;
            this.comingMobilities.push(mobilityId);
            this.comingRequests.push(this.nowRequestingId);
          } else {
            this.timeoutDialog = true;
            setTimeout(() => {
              this.timeoutDialog = false;
            }, 10000);
          }
          this.nowRequestingId = null;
        }
      }
      if (this.comingRequests.length > 0) {
        var deleteRequests = [];
        var deleteComingMobilities = [];
        for (i = 0; i < this.comingRequests.length; i++) {
          query = "?id=" + this.comingRequests[i];
          getRequestDataQuery = await Export.getRequestDataQuery(query);
          var request = getRequestDataQuery.data[0];
          if (request.arrival == "true") {
            deleteRequests.push(this.comingRequests[i]);
            for (var j = 0; j < this.comingMobilities.length; j++) {
              var mId = this.comingMobilities[j];
              accepted = JSON.parse(request.accepted);
              for (var k = 0; k < accepted.length; k++) {
                if (
                  accepted[k].accepted == true &&
                  accepted[k].mobilityId == mId
                ) {
                  deleteComingMobilities.push(mId);
                }
              }
            }
          }
        }
        if (deleteComingMobilities.length > 0) {
          var comingRequests = [];
          var comingMobilities = [];
          for (i = 0; i < this.comingRequests.length; i++) {
            if (deleteRequests.indexOf(this.comingRequests[i]) == -1) {
              comingRequests.push(this.comingRequests[i]);
            }
          }
          this.comingRequests = comingRequests;
          if (this.comingRequests.length == 0) {
            this.comingRequests = [];
          }
          for (i = 0; i < this.comingMobilities.length; i++) {
            if (
              deleteComingMobilities.indexOf(this.comingMobilities[i]) == -1
            ) {
              comingMobilities.push(this.comingMobilities[i]);
            }
          }
          this.comingMobilities = comingMobilities;
          if (this.comingMobilities.length == 0) {
            this.comingMobilities = [];
          }
        }
      }
      this.getMobilityDataNum += 1;
      //>=10で30秒毎
      if (this.getMobilityDataNum >= 10) {
        var getOperation = await Export.getOperation();
        this.operationCommand = getOperation.data[0];
        this.getMobilityDataNum = 0;
      }*/
    },
    is_json(data) {
      try {
        JSON.parse(data);
      } catch (error) {
        return false;
      }
      return true;
    },
    resetMap() {
      /*this.$refs.map.mapObject.setView(
        latLng(36.95607049443559, 140.41183792093346),
        16
      );*/
      this.displayMap = false;
      this.$nextTick(() => {
        this.displayMap = true;
      });
    },
    getCurrentPosition(options) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });
    },
    getBusPosition() {
      var ths = this;
      this.watch_id = navigator.geolocation.watchPosition(
        this.successGetPosition,
        function (e) {
          console.log(e);
          ths.errorMSG += e;
          navigator.geolocation.clearWatch(ths.watch_id);
          ths.getBusPosition();
        },
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 2000 }
      );
    },
    successGetPosition(position) {
      store.state.busLatLng_lat_1 = position.coords.latitude;
      store.state.busLatLng_lon_1 = position.coords.longitude;
      if (position.coords.heading != null) {
        this.busHeading_1 = position.coords.heading;
      }
      this.busSpeed_1 = position.coords.speed;
    },
    popupContent(id, passengers, capacity) {
      if (this.inBreakMobilities.indexOf(String(id)) == -1) {
        return passengers + "/" + capacity + "<span>人</span>";
      } else {
        return "<span>休憩中</span>";
      }
    },
    liconUrl(id) {
      if (this.inBreakMobilities.indexOf(id) != -1) {
        if (id != this.currentMobilityId) {
          return "images/mobile_icon_break.png";
        } else {
          return "images/mobile_icon_blank.png";
        }
      }
      if (
        this.comingMobilities.indexOf(String(id)) != -1 &&
        this.inBreakMobilities.indexOf(id) == -1
      ) {
        if (id != this.currentMobilityId) {
          return "images/mobile_icon_on.png";
        } else {
          return "images/mobile_icon_blank.png";
        }
      }
      if (
        this.comingMobilities.indexOf(String(id)) == -1 &&
        this.inBreakMobilities.indexOf(id) == -1
      ) {
        if (id != this.currentMobilityId) {
          return "images/mobile_icon_off.png";
        } else {
          return "images/mobile_icon_blank.png";
        }
      }
    },
    selectToGo(id) {
      if (this.homeLat != null && this.homeLon != null) {
        var busStopList = this.busStop;
        for (var i = 0; i < busStopList.length; i++) {
          if (busStopList[i].id == id) {
            this.busStopToGo = busStopList[i];
          }
        }
        this.$emit("busStopClick");
      }
    },
    homeClick() {
      this.$emit("homeClick");
    },
    setCurrentPositionToCenter() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            let coords = position.coords;
            // 緯度経度だけ取得
            var lat = coords.latitude;
            var lon = coords.longitude;
            this.$refs.map.mapObject.setView([lat, lon]);
          }.bind(this),
          function (error) {
            alert(
              "現在位置の取得に失敗しました。設定で位置情報をONにしてください。Error:" +
                error
            );
          }
        );
      } else {
        // エラー処理を書く
      }
    },
  },
  computed: {
    currentMobilityId: {
      get() {
        return store.state.currentMobilityId;
      },
      set(value) {
        store.state.currentMobilityId = value;
      },
    },
    driverMode: {
      get() {
        return store.state.driverMode;
      },
      set(value) {
        store.state.driverMode = value;
      },
    },
    center: {
      get() {
        var center = [store.state.center_lat, store.state.center_lon];
        return center;
      },
      set(value) {
        store.state.center_lat = value.lat;
        store.state.center_lon = value.lng;
      },
    },
    bounds() {
      var latLng = [];
      for (var i = 0; i < this.busStopList.length; i++) {
        latLng.push([
          Number(this.busStopList[i].latlon_lat),
          Number(this.busStopList[i].latlon_lon),
        ]);
      }
      var bounds = latLngBounds(latLng);
      return bounds;
    },
    busStopList: {
      get() {
        return store.state.busStopList;
      },
      set(value) {
        store.state.busStopList = value;
      },
    },
    busStop() {
      var busStop = [];
      for (var i = 0; i < this.busStopList.length; i++) {
        busStop.push({
          id: this.busStopList[i].id,
          name: this.busStopList[i].name,
          latlon: latLng(
            Number(this.busStopList[i].latlon_lat),
            Number(this.busStopList[i].latlon_lon)
          ),
          titles: this.busStopList[i].titles,
          cate: this.busStopList[i].cate,
        });
      }
      return busStop;
    },
    busLatLng: {
      get() {
        var busLatLng = [
          store.state.busLatLng_lat_1,
          store.state.busLatLng_lon_1,
        ];
        return busLatLng;
      },
      set(value) {
        store.state.busLatLng = value;
      },
    },
    busHeading_1: {
      get() {
        return store.state.busHeading_1;
      },
      set(value) {
        store.state.busHeading_1 = value;
      },
    },
    busRotationAngle_1() {
      return this.busHeading_1 + 90;
    },
    busSpeed_1: {
      get() {
        return store.state.busSpeed_1;
      },
      set(value) {
        store.state.busSpeed_1 = value;
      },
    },
    currentBusStopId: {
      get() {
        return store.state.currentBusStopId;
      },
      set(value) {
        store.state.currentBusStopId = value;
      },
    },
    currentBusStopName() {
      var name = "";
      for (var i = 0; i < this.busStop.length; i++) {
        if (this.busStop[i].id == this.currentBusStopId) {
          name = this.busStop[i].name;
        }
      }
      return name;
    },
    errorMSG: {
      get() {
        return store.state.errorMSG;
      },
      set(value) {
        store.state.errorMSG = value;
      },
    },
    nowRequestingId: {
      get() {
        return store.state.nowRequestingId;
      },
      set(value) {
        store.state.nowRequestingId = value;
      },
    },
    comingMobility: {
      get() {
        return store.state.comingMobility;
      },
      set(value) {
        store.state.comingMobility = value;
      },
    },
    comingMobilities: {
      get() {
        return store.state.comingMobilities;
      },
      set(value) {
        store.state.comingMobilities = value;
      },
    },
    comingRequests: {
      get() {
        return store.state.comingRequests;
      },
      set(value) {
        store.state.comingRequests = value;
      },
    },
    mobilityData: {
      get() {
        return store.state.mobilityData;
      },
      set(value) {
        store.state.mobilityData = value;
      },
    },
    timeoutDialog: {
      get() {
        return store.state.timeoutDialog;
      },
      set(value) {
        store.state.timeoutDialog = value;
      },
    },
    inBreakMobilities: {
      get() {
        return store.state.inBreakMobilities;
      },
      set(value) {
        store.state.inBreakMobilities = value;
      },
    },
    getMobilityDataTimerId: {
      get() {
        return store.state.getMobilityDataTimerId;
      },
      set(value) {
        store.state.getMobilityDataTimerId = value;
      },
    },
    mapHeight() {
      if (this.driverMode == true) {
        return { height: "90vh" };
      } else {
        var h = window.innerHeight - this.headerHeight;
        return { height: h + "px" };
      }
    },
    headerHeight: {
      get() {
        return store.state.headerHeight;
      },
      set(value) {
        store.state.headerHeight = value;
      },
    },
    outOfService: {
      get() {
        return store.state.outOfService;
      },
      set(value) {
        store.state.outOfService = value;
      },
    },
    operationCommand: {
      get() {
        return store.state.operationCommand;
      },
      set(value) {
        store.state.operationCommand = value;
      },
    },
    busStopToGo: {
      get() {
        return store.state.busStopToGo;
      },
      set(value) {
        store.state.busStopToGo = value;
      },
    },
    home: {
      get() {
        return store.state.home;
      },
      set(value) {
        store.state.home = value;
      },
    },
    homeLat: {
      get() {
        return store.state.homeLat;
      },
      set(value) {
        store.state.homeLat = value;
      },
    },
    homeLon: {
      get() {
        return store.state.homeLon;
      },
      set(value) {
        store.state.homeLon = value;
      },
    },
    crossLatlon: {
      get() {
        return store.state.crossLatlon;
      },
      set(value) {
        store.state.crossLatlon = value;
      },
    },
    btmMsg: {
      get() {
        return store.state.btmMsg;
      },
      set(value) {
        store.state.btmMsg = value;
      },
    },
    numbers: {
      get() {
        return store.state.numbers;
      },
      set(value) {
        store.state.numbers = value;
      },
    },
    getCrewsInterval: {
      get() {
        return store.state.getCrewsInterval;
      },
      set(value) {
        store.state.getCrewsInterval = value;
      },
    },
  },
  watch: {},
};
</script>
<style>
.wide-btn {
  font-size: 30px !important;
  font-weight: bold !important;
  margin: 10px 0;
}
.busStopPopup {
  top: -130px;
}
.busPopup .leaflet-popup-content-wrapper,
.busPopup .leaflet-popup-tip {
  background-color: #fff;
  color: #333;
  font-size: 20px;
  text-align: center;
}
.busPopup .leaflet-popup-content span {
  font-size: 15px;
}
.busPopup .leaflet-popup-content {
  margin: 5px;
  width: 80px;
  height: 30px;
}
.leaflet-popup-tip-container {
  display: none !important;
}
.toCurrentPosition {
  position: absolute;
  z-index: 20;
  width: 15vw;
  top: 3vw;
  right: 3vw;
}
</style>
